import {t} from '../../../common/getTranslations';
import {ProductTypeVo} from '../../../common/shared/api/nicolas/vo/ProductTypeVo.enum';
import {TicketSalesVo} from '../../../common/shared/api/nicolas/vo/TicketSalesVo.interface';

export function getTicketSalesPaidText(ticketSales: TicketSalesVo): string {
  switch (ticketSales.product_type) {
    case ProductTypeVo.Buy:
      // 소장권 1장
      return t('common_ticket_possession_amount', {
        values: {value: 1},
      });
    case ProductTypeVo.Rent:
      // 대여권 1장
      return t('common_ticket_rental_amount', {
        values: {value: 1},
      });
    case ProductTypeVo.WaitFree:
      // 기다무 대여권
      return t('common_ticket_rental_wuf');
    /** @deprecated */
    case ProductTypeVo.WaitFreePlus:
      return '레전드패스';
    default:
      return '';
  }
}
